import React from 'react';
import Row from 'kepler/lib/components/Row';
import Col from 'kepler/lib/components/Col';
import PropTypes from 'prop-types';
import getContent from '../lib/dictionaryFetcher';
import { productsToFPTIMapping } from '../lib/quizStaticMapping';
import { extend, get } from 'lodash';
class DeveloperProductUncollapsed extends React.Component {
  learnMoreFpti = productName => {
    const productSplit = get(productsToFPTIMapping, `${productName}`, '').split(
        ':'
      ),
      { location, fptiHelper } = this.props;
    let fptiOptions = {
      page: 'main:businessweb:mep:dashboard:main:quiz:results',
      link: 'learn_more',
      prod: productSplit[0],
      entry_point: get(location, 'search', '').includes('appcenter=true')
    };
    if (productSplit[1]) extend(fptiOptions, { product_type: productSplit[1] });
    fptiHelper.fptiClick(fptiOptions);
  };
  render() {
    const { toggleProduct, productName, resultData, isCompleted } = this.props;
    return (
      <Row className="results-developer-uncollapsed">
        <div className="results-uncollapsed-cancel" style={{ top: '7px' }}>
          <button
            className="results-cancel add-focus-visible"
            aria-label={getContent('quiz', 'results.remove')}
            onClick={e => {
              e.preventDefault();
              toggleProduct(productName, true, 'developerProducts');
            }}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close results-uncollapsed-cancel-icon" />
          </button>
        </div>
        <Col
          className="icon-developer-mobile-container"
          sm="10%"
          style={{ alignSelf: 'flex-start' }}
        >
          <div
            className="results-icon-container"
            style={{
              background: `url(${resultData.icon}) center center/19px 19px no-repeat #FFFFFF`,
              width: '36px',
              height: '36px'
            }}
          />
        </Col>
        <Col
          className="content-developer-mobile-container"
          sm="80%"
          style={{ paddingLeft: '5px' }}
        >
          <h3
            className="results-uncollapsed-title"
            style={{ fontSize: '15px' }}
          >
            {resultData.header}
          </h3>
          {isCompleted && (
            <span className="ppvx_badge ppvx_badge--type_success ppvx_badge--status">
              {getContent('quiz', 'results.existingProduct')}
            </span>
          )}
          <p
            className="results-uncollapsed-subtext"
            style={{ fontSize: '13px' }}
          >
            {resultData.subText}{' '}
            <a
              target="_blank"
              onClick={() => {
                this.learnMoreFpti(productName);
              }}
              href={resultData.link}
            >
              {getContent('quiz', 'results.product.link')}
            </a>
          </p>
        </Col>
      </Row>
    );
  }
}
DeveloperProductUncollapsed.propTypes = {
  toggleProduct: PropTypes.func,
  productName: PropTypes.string,
  resultData: PropTypes.object,
  isCompleted: PropTypes.bool,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default DeveloperProductUncollapsed;
